// Copyright © 2021 Move Closer
/**
 * Tile's sizing variant.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var TileSize;
(function (TileSize) {
    TileSize["XL"] = "XL";
    TileSize["L"] = "L";
    TileSize["S"] = "S";
})(TileSize || (TileSize = {}));
